import IQueries from '@/interfaces/IQueries';

// Path with parameters
const planetDescription: IQueries = {
    planetDescriptionList: {
        path: '/astrology/planet_descriptions',
        method: 'GET'
    },
    planetDescriptionCreate: {
        path: '/astrology/planet_descriptions',
        method: 'POST'
    },
    planetDescriptionDetail: {
        path: '/astrology/planet_descriptions/',
        method: 'GET'
    },
    planetDescriptionChange: {
        path: '/astrology/planet_descriptions/',
        method: 'PUT'
    }
};

export default planetDescription;